import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orders: {},
  storeOrders: [],
  storeRecord: [],
  recordList: [],
  orderById: {},
  searchOrder: [],
  invoiceDetails: [],
  isTrack: {},
  lastOrderId: "",
  trackData: {},
  status: "idle",
  error: null,
  cancel: false,
  loading: false,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload;
      state.status = "succeeded";
    },
    setStoreOrders: (state, action) => {
      state.storeOrders = action.payload;
      state.status = "succeeded";
    },
    setStoreRecords: (state, action) => {
      state.storeRecord = action.payload;
      state.status = "succeeded";
    },
    setRecordList: (state, action) => {
      state.recordList = action.payload;
      state.status = "succeeded";
    },
    setLastOrderId: (state, action) => {
      state.lastOrderId = action.payload;
      state.status = "succeeded";
    },
    searchOrders: (state, action) => {
      state.searchOrder = action.payload;
      state.status = "succeeded";
    },
    updateOrder: (state, action) => {
      const { orderId, statusKey } = action.payload;

      // Update the specific order's status in the state
      state.orders = state.orders?.orders?.map((order) => {
        if (order.OID === orderId) {
          return {
            ...order,
            ...statusKey,
          };
        }

        return order;
      });
      state.status = "succeeded";
    },
    setOrderById: (state, action) => {
      state.orderById = action.payload;
      state.status = "succeeded";
    },
    setInvoiceDetails: (state, action) => {
      const { orderId, invoiceData } = action.payload;

      // Check if the orderId already exists in the invoiceDetails array
      const existingOrderIndex = state.invoiceDetails.findIndex(
        (item) => item.orderId === orderId
      );

      if (existingOrderIndex !== -1) {
        // If the orderId already exists, update its invoiceData
        state.invoiceDetails[existingOrderIndex].invoiceData = invoiceData;
      } else {
        // If the orderId doesn't exist, create a new object for this order
        state.invoiceDetails.push({
          orderId,
          invoiceData: invoiceData,
        });
      }

      state.status = "succeeded";
    },
    setTrackOrderData: (state, action) => {
      state.trackData = action.payload;
      state.status = "succeeded";
    },
    setCancel: (state) => {
      state.cancel = true;
    },
    setLoading: (state, action) => {
      state.status = "loading";
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setIsTrack: (state, action) => {
      state.isTrack = action.payload;
    },
  },
});

export const {
  setOrders,
  setStoreOrders,
  searchOrders,
  setInvoiceDetails,
  setStoreRecords,
  setLastOrderId,
  setRecordList,
  setLoading,
  setOrderById,
  updateOrder,
  setTrackOrderData,
  setError,
  setCancel,
  setIsTrack,
} = orderSlice.actions;

export default orderSlice.reducer;
